import React, { useState } from 'react';

interface TabProps {
  label: string;
  children: React.ReactNode;
}

const Tab: React.FC<TabProps> = ({ children }) => {
  return <>{children}</>;
};

interface TabsProps {
  children: React.ReactElement<TabProps>[];
  initialActiveTab?: string;
}

const Tabs: React.FC<TabsProps> = ({ children, initialActiveTab }) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab || children[0]?.props.label);

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="flex border-b border-border-primary mb-4">
        {children.map((child) => {
          const { label } = child.props;
          return (
            <button
              key={label}
              className={`py-2 px-4 text-sm font-medium focus:outline-none ${
                activeTab === label
                  ? 'border-b-2 border-primary text-primary'
                  : 'text-text-secondary hover:text-text-primary'
              }`}
              onClick={() => setActiveTab(label)}
            >
              {label}
            </button>
          );
        })}
      </div>
      <div className="tab-content">
        {children.map((child) => {
          if (child.props.label === activeTab) {
            return <div key={child.props.label}>{child.props.children}</div>;
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default Tabs;
export { Tab }; // Export Tab for convenience, though it's mainly for typing children
